module.exports = __webpack_public_path__ + "static/bbg-b69a8b9286fa62d33f7aec44ba050eba.jpg";